// Header
export const DOCUMENT_ID = "parkDocumentHeaderId";
export const POST_DOCUMENT_ID = "postDocumentHeaderId";
export const DOCUMENT_TYPE = "documentTypeId";
export const VENDOR_ID = "vendorId";
export const INVOICE_NUMBER = "invoiceNumber";
export const INVOICE_REFERENCE = "invoiceRef";
export const INVOICE_AMOUNT = "invoiceAmount";
export const INVOICE_CURRENCY = "invoiceCurrency";
export const APPROVED_AMOUNT = "approvedAmount";
export const PAYMENT_TERMS = "paymentTerms";
export const DUE_DATE = "dueDate";
export const INVOICE_DATE = "invoiceDate";
export const BASELINE_DATE = "baselineDate";
export const PAYMENT_METHODS = "paymentMethod";
export const POSTING_DATE = "postingDate";
export const POSTING_MONTH = "postingMonth";
export const YEAR = "postingYear";
export const PAYMENT_BLOCK = "paymentBlock";
export const BLOCK_DATE = "blockDate";
export const BLOCK_BY = "blockBy";
export const ATTACHMENT = "attachment";
export const ATTACHMENT_ID = "attachmentId";
export const COMMENT = "comments";
export const DOC_STATUS = "documentStatus";

export const COMMUNITY = 'communityName';
export const ZONE = 'distZoneId';
export const BLOCK = 'distBlockId';
export const PROPERTY = 'distPropertyId';

// line items
export const PARK_ITEM_ID = "parkDocumentLineItemId";
export const LINE_ITEMS = "lineItems";
export const CHECK = "check";
export const GL_ACCOUNT_ID = "glMasterId";
export const ALT_GL_ACCOUNT_ID = "alternativeAccount";
export const DRCR = "drCr";
export const UNIT = "numberOfUnits";
export const RATE_PER_UNIT = "ratePerUnit";
export const AMOUNT = "amount";
export const APPROVED_UNIT = "approvedUnits";
export const APPROVED_RATE_PER_UNIT = "approvedRatePerUnit";
export const APP_AMOUNT = "appAmount";
export const BUDGET_YEAR = "budgetYear";
export const BUDGET_MONTH = "budgetMonth";
export const BUDGET_START_MONTH = "budgetMonthStart";
export const BUDGET_END_MONTH = "budgetMonthEnd";
export const ITEM_TEXT = "itemText";
export const LINE_ITEM_TYPE = "lineItemType";
export const APPROVAL_STATUS = "approvalStatus";
export const LINE_ITEM_COMMENTS = "lineItemComment";
export const SHORT_DESC = "accountShortDesc";

export const drcrOptions = [
  { label: "Dr", value: "DR" },
  { label: "Cr", value: "CR" },
];